const config = {
  baseApiApplication: process.env.REACT_APP_API_Application,
  bucket_name: `https://${process.env.REACT_APP_NEXT_PUBLIC_s3_public_bucket}.s3.amazonaws.com`,
  secret_key: process.env.REACT_APP_SECRET_KEY || "secret",
};

export default config;
